import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);


const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/mbox',
    name: 'mbox',
    component: () => import('../views/mbox.vue')
  },
    {
      path: '/studio',
      name: 'studio',
      beforeEnter: (to, from, next) => {
        // 检测设备类型
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        // 根据设备类型重定向
        if (isMobile) {
          next(); // 保持原路由，访问手机版
        } else {
          next({ name: 'studioPc' }); // 重定向到PC版
        }
      },
      component: () => import('../views/studioLandingPage.vue')
    },
    {
      path: '/studioPc',
      name: 'studioPc',
      beforeEnter: (to, from, next) => {
        // 检测设备类型
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        // 根据设备类型重定向
        if (isMobile) {
          next({ name: 'studio' }); // 重定向到移动版
        } else {
          next(); // 保持原路由，访问PC版
        }
      },
      component: () => import('../views/studioLandingPageLateral.vue')
    },
  {
    path: '/aiqr',
    name: 'aiqr',
    component: () => import('../views/face-ai.vue')
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('../views/studioLandingPageLateralMessage.vue')
  }
]

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router
